import { Text } from "@mantine/core"
import { useSuspenseQueryGet } from "@/typed-client/hooks/use-suspense-query-get"
import { getFormattedDate } from "@/utils/get-formatted-date"
import { t } from "i18next"

export function ActivityTitle({
  activityId,
  onTitleChange,
}: {
  activityId: number
  onTitleChange?: (title: string) => void
}) {
  const { data: activity } = useSuspenseQueryGet("/api/Activity/GetActivity", {
    activityId,
  })
  let title: string
  if (!activity) {
    title = t("DeletedOrNoPermission")
    onTitleChange?.(title)
    return (
      <Text span inherit>
        {title}
      </Text>
    )
  }
  const dateString = getFormattedDate(activity?.date, "DD.MM.YYYY")
  title =
    (
      dateString + (activity?.title?.text ? " " + activity.title.text : "")
    ).trim() || `Aktivität #${activityId}`
  React.useEffect(() => {
    onTitleChange?.(title)
  }, [title, onTitleChange])
  return (
    <Text span inherit>
      {title}
    </Text>
  )
}
